import './styles/welcomeDialog.css';
import Dialog from '../../subcomponents/Dialog';
import { useGameStore } from '../../../store/gameStore';
import { useShallow } from 'zustand/shallow';
import TextField from '../../subcomponents/TextField';
import Btn from '../../subcomponents/Btn';

type WelcomeDialogProps = {
  open: boolean;
  onClose: () => void;
};

function WelcomeDialog(props: WelcomeDialogProps) {
  const { open, onClose } = props;

  // Subscribe to game store
  const { username, setUsername } = useGameStore(
    useShallow((state) => ({
      username: state.username,
      setUsername: state.setUsername,
    }))
  );

  return (
    <Dialog open={open} onClose={onClose} title="WELCOME">
      <div className="welcome-container">
        <div className="welcome-text">
          Enter a leaderboard <b>USERNAME</b> to get started. You can always change this later in{' '}
          <b>SETTINGS</b>.
        </div>
        <div className="flex my-2 justify-center items-center">
          <TextField value={username} onChange={setUsername} placeholder="[ Enter name ]" />
        </div>
        <div className="flex justify-center">
          <Btn text="OK" onClick={onClose} />
        </div>
      </div>
    </Dialog>
  );
}

export default WelcomeDialog;
